import { useEffect, useState } from "react";
import { DataFilter5 } from "../../RemoteAbstractAction/components/com/quickdataerp/uicomponents/reports/DataFilter5";
import { ReportViewer } from "../../RemoteAbstractAction/components/com/quickdataerp/uicomponents/reports/ReportViewer";
import { RemoteDocumentViewer } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/RemoteDocumentViewer";
import { CDPAdjustmentAction } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/CDPAdjustmentAction";
import { PrintJson } from "../../theme/Component/PrintJson";
import { env } from "../../../env";
import { Modal } from "../../theme/Component/Modal";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { AbstractStep } from "./AbstractStep";
import { RPAdjustmentAction } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/RPAdjustmentAction";
import { OBAdjustmentAction } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/OBAdjustmentAction";
import { InventoryFactory } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/InventoryFactory";
import { InventoryOutCostFactory } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/InventoryOutCostFactory";
import { ProductionOrderFactory } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/ProductionOrderFactory";
import { InventoryRawMaterialTranslateFactory } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/InventoryRawMaterialTranslateFactory";
import { RemoteComponentManageUBLInvoiceitems } from "../../contract/etapa-contrato/contrac/ublinvoice/ManageAssets/RemoteComponentManageUBLInvoiceitems";
import { RawMaterialToProductionLineAction } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/RawMaterialToProductionLineAction";
import { RegisterMovementBudgetValue } from "../../contabilidad/BudgetMovementFactory/RegisterMovementBudgetValue";
import { BudgetMovementAdjustmentAction } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/BudgetMovementAdjustmentAction";
import { FortnightDocumentStep } from "../../RemoteAbstractAction/components/account/documents/fortnight/gui/FortnightDocumentStep";

interface Props {
    idApplicationInvoker: number;
    slide: any;
    setData: any;
}
export const RemoteComponentProxy = ({ idApplicationInvoker, slide, setData }: Props) => {

    const [properties, setProperties] = useState<any>({});
    const _printLog = env.PRINT_LOG;
    const modalStructure = useModal("Estructura", MODAL_LG);
    const modalDatos = useModal("Datos", MODAL_md);


    useEffect(() => {
        if (slide) {
            setProperties(slide.PROPERTIES);
        }
    }, [slide])

    const enviarForm = (form: any) => {
        setData(form);
    }

    const renderComponent = (name: string) => {
        switch (name) {
            case 'com.quickdataerp.uicomponents.reports.DataFilter5':
                return <DataFilter5 idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES_STRUCTURE} data={slide.PROPERTIES} lastStep={slide.LASTSTEP} setData={enviarForm} />
            case 'com.quickdataerp.uicomponents.reports.ReportViewer':
                return <ReportViewer idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES_STRUCTURE} data={slide.PROPERTIES} lastStep={slide.LASTSTEP} setData={enviarForm} />
            case 'com.quickdataerp.actions.documents.steps.ShowAccountantDocument':
                return <RemoteDocumentViewer idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={{}} lastStep={slide.LASTSTEP} setData={enviarForm} />
            case 'com.quickdataerp.actions.documents.steps.CDPAdjustmentAction':
                //com.quickdataerp.actions.documents.steps.CDPAdjustmentAction
                return <CDPAdjustmentAction idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'com.quickdataerp.actions.documents.steps.RPAdjustmentAction':
                return <RPAdjustmentAction idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'com.quickdataerp.actions.documents.steps.OBAdjustmentAction':
                return <OBAdjustmentAction idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'com.quickdataerp.uicomponents.reports.InventoryEntryStep':
                return <InventoryFactory idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            // return <RemoteComponentManageUBLInvoiceitems idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'com.quickdataerp.uicomponents.reports.InventoryOutputStep':
                return <InventoryOutCostFactory idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'com.quickdataerp.uicomponents.reports.FinishedProductEntryStep':
                return <ProductionOrderFactory idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'com.quickdataerp.uicomponents.reports.RawMaterialToProductionOrderStep':
                return <InventoryRawMaterialTranslateFactory idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'fixedassets.actions.ublinvoiceentryaction.InventoryEntryStep':
                return <RemoteComponentManageUBLInvoiceitems idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'inventory.actions.rawmaterialtoproductionlineaction.InventoryOutputStep':
                return <RawMaterialToProductionLineAction idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'com.quickdataerp.actions.documents.steps.BudgetMovementAdjustmentAction':
                return <BudgetMovementAdjustmentAction idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES_STRUCTURE} lastStep={slide} setData={enviarForm} />
            case 'account.documents.fortnight.gui.FortnightDocumentStep':
                return <FortnightDocumentStep idApplicationInvoker={idApplicationInvoker} properties={slide.PROPERTIES} data={slide.PROPERTIES} lastStep={slide} setData={enviarForm} />
            default:
                return <p>No hay un formato asociado</p>

        }
    }

    return (
        <div className="row">
            {/* <PrintJson json={slide} /> */}
            {_printLog &&
                <div className="col-md-12">
                    <button type="button" title="Estructura" className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none" onClick={() => { modalStructure.open() }}><i className="ri-layout-5-fill"></i></button>
                    <button type="button" title="Datos" className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none" onClick={() => { modalDatos.open() }}><i className="ri-code-fill"></i></button>
                </div>
            }
            <div className="col">
                {slide.COMPONENT_NAME ?
                    <>
                        {renderComponent(slide.COMPONENT_NAME)}
                    </>
                    :
                    <p>Componente no encontrado : {slide.COMPONENT_NAME}</p>
                }
            </div>
            <div className="col-md-12">
                <Modal modal={modalStructure.modal} updateModal={modalStructure.setModal}>
                    {/* <PrintJson json={campos} /> */}
                    <AbstractStep fieldList={slide.PROPERTIES_STRUCTURE} />
                    <hr />

                </Modal>
                <Modal modal={modalDatos.modal} updateModal={modalDatos.setModal}>
                    <PrintJson json={slide.PROPERTIES} />
                </Modal>
            </div>
        </div>
    )
}